module.exports = __webpack_public_path__ + "images/calendar.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/calendar.png
// module id = h3qI
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13